import { render, staticRenderFns } from "./redeem-baner.vue?vue&type=template&id=c8c85d3e"
import script from "./redeem-baner.vue?vue&type=script&lang=js"
export * from "./redeem-baner.vue?vue&type=script&lang=js"
import style0 from "./redeem-baner.vue?vue&type=style&index=0&id=c8c85d3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports